<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span class="spacer"></span>
    <app-menu
      [options]="options$ | async"
      (themeChange)="themeChangeHandler($event)"
    >
    </app-menu>
  </mat-toolbar-row>
</mat-toolbar>

<div fxLayout="row" fxLayout.xs="column">
  <div fxFlex="50">
    <mat-label-tooltip id="sample-firstName" tooltipText="Here is my tooltip"
      >First Name</mat-label-tooltip
    >
    <div>
      <mat-form-field appearance="outline">
        <input matInput placeholder="First Name" />
      </mat-form-field>
    </div>
  </div>
  <div fxFlex="50">
    <mat-label-tooltip>Legal Last Name</mat-label-tooltip>
    <div>
      <mat-form-field appearance="outline">
        <input matInput placeholder="Last Name" />
      </mat-form-field>
    </div>
  </div>
</div>
<div>
  <h1>Sample h1</h1>
</div>
<div>
  <h2>Sample h2</h2>
</div>
<div>
  <h3>Sample h3</h3>
</div>
<div>
  <h4>Sample h4</h4>
</div>
<div>
  <h5>Sample h5</h5>
</div>
<div>
  <h6>Sample h6</h6>
</div>

<div class="labelDiv">
  <mat-label>Is there a joint applicant?</mat-label>
  <div>
    <mat-radio-group>
      <mat-radio-button value="1">Yes</mat-radio-button>
      <mat-radio-button value="2">No</mat-radio-button>
    </mat-radio-group>
  </div>
</div>
<mat-divider></mat-divider>
<div class="labelDiv">
  <mat-checkbox formControlName="confirmationCorrect"
    >I assure that the information provided by me is correct
  </mat-checkbox>
</div>
<div>
  <button>Test Button</button>
</div>
<div>
  <mat-button-toggle>Material Test Button</mat-button-toggle>
</div>
<div>
  <mat-slider></mat-slider>
</div>

<mat-form-field appearance="fill">
  <mat-label>Choose a date (MM/dd/yyyy)</mat-label>
  <input matInput [matDatepicker]="picker" />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>

<h4>Basic native select</h4>
<mat-form-field appearance="fill">
  <select matNativeControl required>
    <option value="volvo">Volvo</option>
    <option value="saab">Saab</option>
    <option value="mercedes">Mercedes</option>
    <option value="audi">Audi</option>
  </select>
</mat-form-field>
